<template>
  <div class="container mt-5">
    <div class="row">
      <!-- Menu anësore (e majtë) -->
      <div class="col-md-3 pe-0">
        <ul class="nav flex-column nav-pills">
          <li v-for="(menu, index) in tabMenu" :key="menu.id" class="nav-item">
            <a
              class="nav-link"
              :class="{ active: activeTab === index }"
              :href="'#tab' + menu.id"
              data-bs-toggle="pill"
              @click.prevent="activeTab = index"
            >
              {{ $t(menu.title) }}
            </a>
          </li>
        </ul>
      </div>
      <!-- Përmbajtja (e djathtë) -->
      <div class="col-md-9 pt-0 ps-0 rounded boxcontainer">
        <div class="tab-content">
          <div
            v-for="(menu, index) in tabMenu"
            :key="menu.id"
            :id="'tab' + menu.id"
            class="tab-pane fade"
            :class="{ 'show active': activeTab === index }"
            style="margin-bottom: 15px;"
          >
            <!-- Nëse ka titlecontent, e shfaqim si titull përveç atyre në content -->
            <h4 v-if="menu.titlecontent" v-html="$t(menu.titlecontent)"></h4>

            <!-- Përmbajtja e menuse -->
            <div v-for="contentItem in Array.isArray(menu.content) ? menu.content : [menu.content]" :key="contentItem.id || contentItem">
              <h4 v-if="contentItem.title" v-html="$t(contentItem.title)"></h4>

              <template v-if="Array.isArray(contentItem.content)">
                <ul>
                  <li v-for="(item, idx) in contentItem.content" :key="idx" v-html="typeof item === 'string' ? $t(item) : ''"></li>
                </ul>
              </template>

              <template v-else-if="typeof contentItem.content === 'string'">
                <div v-html="$t(contentItem.content)"></div>
              </template>

              <template v-else-if="typeof contentItem === 'string'">
                <!-- Nëse contentItem është string (p.sh në rastin kur content është thjesht array stringjesh) -->
                <div v-html="$t(contentItem)"></div>
              </template>

              <template v-else>
                <!-- Asnjë përmbajtje valide -->
              </template>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 0,
      tabMenu: [],
    };
  },
  methods: {
    initTabMenu() {
      this.tabMenu = [
        {
          id: 1,
          title: 'keshilli_prokurorial.njshp.tab1.title',
          content: [
            {
              id: 1,
              title: 'keshilli_prokurorial.njshp.tab1.content1.title',
              content: 'keshilli_prokurorial.njshp.tab1.content1.content',
            },
          ],
        },
        {
          id: 2,
          title: 'keshilli_prokurorial.njshp.tab2.title',
          content: [
            {
              id: 1,
              title: 'keshilli_prokurorial.njshp.tab2.content1.title',
              content: 'keshilli_prokurorial.njshp.tab2.content1.content',
            },
          ],
        },
        {
          id: 3,
          title: 'keshilli_prokurorial.njshp.tab3.title',
          content: [
            {
              id: 1,
              title: 'keshilli_prokurorial.njshp.tab3.content1.title',
              content: 'keshilli_prokurorial.njshp.tab3.content1.content',
            },
          ],
        },
        {
          id: 4,
          title: 'keshilli_prokurorial.njshp.tab4.title',
          content: [
            {
              id: 1,
              title: 'keshilli_prokurorial.njshp.tab4.content1.title',
              content: 'keshilli_prokurorial.njshp.tab4.content1.content',
            },
          ],
        },
        {
          id: 5,
          title: 'keshilli_prokurorial.njshp.tab5.title',
          content: [
            {
              id: 1,
              title: 'keshilli_prokurorial.njshp.tab5.content1.title',
              content: 'keshilli_prokurorial.njshp.tab5.content1.content',
            },
          ],
        },
         {
          id: 6,
          title: 'keshilli_prokurorial.njshp.tab6.title',
          content: [
            {
              id: 1,
              title: 'keshilli_prokurorial.njshp.tab6.content1.title',
              content: 'keshilli_prokurorial.njshp.tab6.content1.content',
            },
          ],
        }
      ];
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initTabMenu();
    },
  },
  created() {
    this.initTabMenu();
  },
};
</script>

<style scoped>
/* Efekti për animacion fade-in dhe slide */
.tab-pane {
  transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
  transform: translateX(20px);
  opacity: 0;
}

.tab-pane.active.show {
  transform: translateX(0);
  opacity: 1;
}

/* Stilimi i linkut të tabs */
.nav-link {
  border-radius: 15px; /* Radius normal */
  transition: border-radius 0.3s ease;
}

/* Kur është aktiv, bëhet me kënd të drejtë */
.nav-link.active {
  border-radius: 0 !important;
}

.row div ul .active,
.tab-content {
  background-color: var(--color-system-background);
}

.tab-content {
  padding: 40px;
}

li a {
  color: #101826;
}

li .active {
  color: #101826 !important;
  font-weight: bold;
  border-left: 3px solid var(--color-system-primary);
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

li a {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

@media (max-width: 767px) {
  .boxcontainer {
    margin-left: 12px;
  }
}
</style>
